import { KeyEvent } from './java/AwtEvent';
import { GameObject } from './GameObject';
import { Handler } from './Handler';
import { Player } from './Player';
import { Menu } from './Menu';
import { STATE } from './STATE';
import { Game } from './Game';

export class KeyInput {
  private handler: Handler;

  constructor(handler: Handler, _game: Game) {
    this.handler = handler;
  }

  keyPressed(e: KeyEvent): void {
    const key = e.getKeyCode();

    if (Game.gameState === STATE.Game) {
      const player = this.findPlayer();
      if (player !== null) {
        if (key === KeyEvent.VK_W || key === KeyEvent.VK_UP) player.moveUp = true;
        if (key === KeyEvent.VK_S || key === KeyEvent.VK_DOWN) player.moveDown = true;
        if (key === KeyEvent.VK_D || key === KeyEvent.VK_RIGHT) player.moveRight = true;
        if (key === KeyEvent.VK_A || key === KeyEvent.VK_LEFT) player.moveLeft = true;
        if (key === KeyEvent.VK_SHIFT) player.dashInput = true;
        if (key === KeyEvent.VK_E) player.slowmoInput = true;
        if (key === KeyEvent.VK_F) player.shootInput = true;
        if (key === KeyEvent.VK_Q) player.parryInput = true;
      }
    }

    // ESC — context-sensitive
    if (key === KeyEvent.VK_ESCAPE) {
      switch (Game.gameState) {
        case STATE.Game:
        case STATE.Shop:
          Game.pausedFrom = Game.gameState;
          Game.gameState = STATE.Paused;
          break;
        case STATE.Paused:
          Game.gameState = Game.pausedFrom;
          break;
        case STATE.Select:
        case STATE.About:
        case STATE.Update_Notes:
        case STATE.Credits:
        case STATE.MusicPlayer:
        case STATE.Statistics:
        case STATE.AchievementsPage:
        case STATE.Customize:
        case STATE.CoinShopPage:
        case STATE.DailyPage:
          Game.gameState = STATE.Menu;
          break;
        case STATE.Loadout:
          Game.gameState = STATE.Select;
          break;
        case STATE.Settings:
          Game.gameState = (Menu.settingsReturnTo !== null) ? Menu.settingsReturnTo : STATE.Menu;
          Menu.settingsReturnTo = null;
          break;
        case STATE.Help:
          Game.gameState = STATE.Menu;
          break;
        case STATE.HelpENG:
        case STATE.HelpNLD:
        case STATE.HelpDEU:
        case STATE.HelpFRA:
        case STATE.HelpRUS:
        case STATE.HelpSPA:
          Game.gameState = STATE.Help;
          break;
        case STATE.End:
          Game.gameState = STATE.Menu;
          break;
        default:
          break;
      }
    }

    if (key === KeyEvent.VK_P) {
      if (Game.gameState === STATE.Game) {
        Game.pausedFrom = STATE.Game;
        Game.gameState = STATE.Paused;
      } else if (Game.gameState === STATE.Paused) {
        Game.gameState = Game.pausedFrom;
      }
    }

    if (key === KeyEvent.VK_SPACE) {
      if (Game.gameState === STATE.Game) Game.gameState = STATE.Shop;
      else if (Game.gameState === STATE.Shop) Game.gameState = STATE.Game;
    }
  }

  keyReleased(e: KeyEvent): void {
    const key = e.getKeyCode();

    const player = this.findPlayer();
    if (player !== null) {
      if (key === KeyEvent.VK_W || key === KeyEvent.VK_UP) player.moveUp = false;
      if (key === KeyEvent.VK_S || key === KeyEvent.VK_DOWN) player.moveDown = false;
      if (key === KeyEvent.VK_D || key === KeyEvent.VK_RIGHT) player.moveRight = false;
      if (key === KeyEvent.VK_A || key === KeyEvent.VK_LEFT) player.moveLeft = false;
    }
  }

  /**
   * Clear all held movement keys. A browser tab can lose focus mid-run and never deliver
   * the keyup, which would otherwise leave the player gliding into a wall; AWT had no
   * equivalent failure mode.
   */
  releaseAll(): void {
    const player = this.findPlayer();
    if (player !== null) {
      player.moveUp = false;
      player.moveDown = false;
      player.moveLeft = false;
      player.moveRight = false;
    }
  }

  private findPlayer(): Player | null {
    for (let i = 0; i < this.handler.getObjects().length; i++) {
      const obj: GameObject = this.handler.getObjects()[i];
      if (obj instanceof Player) return obj;
    }
    return null;
  }
}
